export const GEAR_USE_SORTS = {
  totalItemCount: CreateGearUseSort('TotalItemCount', 'Total Item Count', 'The sum of the amount of a given item in kill events for the set filters.'),
  totalPlayerCount: CreateGearUseSort(
    'TotalPlayerCount',
    'Total Player Count',
    'The amount of players that were seen in kill events with a given item for the set filters.'
  ),
  totalEventCount: CreateGearUseSort('TotalEventCount', 'Total Event Count', 'The amount of kill events with a given item for the set filters.'),
  totalKillerCount: CreateGearUseSort(
    'TotalKillerCount',
    'Total Killer Count',
    'The amount of players that killed someone in a kill event with a given item for the set filters.'
  ),
  totalVictimCount: CreateGearUseSort(
    'TotalVictimCount',
    'Total Victim Count',
    'The amount of players that died in a kill event with a given item for the set filters.'
  ),
  killDeathRatio: CreateGearUseSort('KillDeathRatio', 'Kill Death Ratio', 'The ratio of kills to deaths for players with a given item for the set filters.'),
  totalKillFame: CreateGearUseSort('TotalKillFame', 'Total Kill Fame', 'The sum of the kill fame for players with a given item for the set filters.'),
  averageKillFame: CreateGearUseSort('AverageKillFame', 'Average Kill Fame', 'The average kill fame for players with a given item for the set filters.'),
  totalDeathFame: CreateGearUseSort('TotalDeathFame', 'Total Death Fame', 'The sum of the death fame for players with a given item for the set filters.'),
  averageDeathFame: CreateGearUseSort('AverageDeathFame', 'Average Death Fame', 'The average death fame for players with a given item for the set filters.'),
  totalDamageDone: CreateGearUseSort('TotalDamageDone', 'Total Damage Done', 'The sum of the damage done by players with a given item for the set filters.'),
  averageDamageDone: CreateGearUseSort('AverageDamageDone', 'Average Damage Done', 'The average damage done by players with a given item for the set filters.'),
  totalSupportHealingDone: CreateGearUseSort(
    'TotalSupportHealingDone',
    'Total Support Healing Done',
    'The sum of the support healing done by players with a given item for the set filters.'
  ),
  averageSupportHealingDone: CreateGearUseSort(
    'AverageSupportHealingDone',
    'Average Support Healing Done',
    'The average support healing done by players with a given item for the set filters.'
  ),
};

export interface GearUseSort {
  name: string;
  displayName: string;
  description: string;
}

export function CreateGearUseSort(name: string, displayName: string, description: string): GearUseSort {
  return { name, displayName, description };
}

export function GetAllGearUseSorts(): GearUseSort[] {
  return Object.values(GEAR_USE_SORTS);
}
